import { useSelector } from "react-redux";
import { useAppDispatch } from "../../redux/store";
import { setItem } from "../../redux/Reducers/createPostReducer";
import DropDown from "../DropDown";
import Section from "./Section";
import { T } from "react-translator-component";

interface Props {
  groups: any[]
}

export default function SelectGroup({ groups }: Props) {
  const dispatch = useAppDispatch();

  const group = useSelector((state: any) => state.createPost.values.group);
  const error = useSelector((state: any) => state.createPost.errors.group);

  return (
    <Section
      title={`${T("group")}${T("required")}`}
      body={(
        <DropDown
          style={{ marginTop: -10 }}
          title={T("group")}
          star
          options={groups}
          value={group}
          error={error !== ""}
          errorMessage={error}
          onChange={(e) => dispatch(setItem({key: 'group', value: String(e.target.value)}))}
        />
      )}
    />
  )
}
